// extracted by mini-css-extract-plugin
export default {"menu":"NavBar_menu__2FCuG","menu-link":"NavBar_menu-link__Z5RSd"};